import React from 'react';

import { loadContainers } from '@eika-infrastruktur/render';

import { APP_NAMESPACE, defaultConfig } from '../default-config';
import Form from './widgets/cookie-form';
import Modal from './widgets/popup';

import './styles/main.scss';

const renderApp = (MyApp: React.ComponentType, namespace: string) => {
    loadContainers(
        namespace,
        () => (
            <div className="no-eika-cookieconsent">
                <MyApp />
            </div>
        ),
        defaultConfig,
    );
};

renderApp(Modal, `${APP_NAMESPACE}.popup`);
renderApp(Form, `${APP_NAMESPACE}.form`);
